export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export const assureProperCentRounding = (number: number) => {
  return Math.round(number * 100) / 100;
};
